import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo3/situacionaula.png";
import Imagen2 from "../../../images/modulo3/emiliaayuda.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 5.mp3";

const Actividad5 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "0" },
    ans2: { value: "", valid: "", correctValue: "1" },
  });
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[4];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo3.content[0].activities[5].name}`,
    linkNext: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[5].path}`,
    titlePrev: `${modulo3.content[0].activities[3].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[3].path}`,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo3.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 5</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Trabaja con un compañero, compañera o familiar.</li>
        <li>
          Observen las imágenes y conversen: ¿estas situaciones ayudan a la
          convivencia en el aula? ¿Por qué? Pueden utilizar las palabras de la
          actividad anterior en su conversación.
        </li>
        <li>
          Luego, marquen con un check (√) la situación que ayuda a la
          convivencia.
        </li>
      </ul>

      <div className="row activities-content mt-5">
        <div className="col-md-10 col-xs-12">
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans1.valid}
              type="checkbox"
              value="1"
              checked={answers.ans1.value === "1"}
              onChange={(event) => handleAnswers(event, "ans1")}
            />
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-10 col-xs-12 mt-5">
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans2.valid}
              type="checkbox"
              value="1"
              checked={answers.ans2.value === "1"}
              onChange={(event) => handleAnswers(event, "ans2")}
            />
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo3.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las imágenes. Dialoguen acerca de las
          preguntas. La idea es darnos cuenta de la importancia de colaborar
          para aprender. En la primera situación no es bueno que nadie comparta
          libro con Jailer; en la segunda, es bueno que Emilia ayude a Martín.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
